import React from 'react';
import {useField} from 'formik';
import {CremaTheme} from '../../types/AppContextPropsType';
import {makeStyles} from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText/FormHelperText';

export const InputCheckbox = (props: any): React.ReactElement => {
  const useStyles = makeStyles((theme: CremaTheme) => ({
    root: {
      color: theme.palette.primary.main,
      '&$checked': {
        color: theme.palette.primary.main,
      },
    },
    checked: {},
  }));
  const classes = useStyles();

  const [field, meta] = useField(props);

  const errorText = meta.error && meta.touched ? meta.error : '';

  const onClick = (e: any) => {
    field.onChange(e);
    props.onChange(e.target.checked);
  };

  return (
    <>
      <FormControlLabel
        label={props.label}
        control={
          <Checkbox
            checked={props.checked}
            classes={classes}
            {...props}
            {...field}
            onChange={onClick}
          />
        }
      />
      {!!errorText ? <FormHelperText>{errorText}</FormHelperText> : null}
    </>
  );
};
